import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash/isEqual';

export const _createSelector = createSelectorCreator(defaultMemoize, isEqual);
